import Ncs from 'ncs'

export default {
  elements: {
    types: ['units']
  },
  filters: {
    values: gon.values,
    dependencyValues: gon.dependencyValues
  },
  result: {
    types: ['frequency', 'full_frequency', 'kwic'],
    defaultType: 'kwic',
    error: {
      contactLink: './contacto',
      contactEmail: 'codolga@cirp.gal'
    },
    kwic: {
      order: {
        orders: [
          {name: 'ncs_documents.data_orde', criteria: [{field: 'ncs_documents.data_orde', asc: true}]},
          {name: 'ncs_documents.outorgante', criteria: [{field: 'ncs_documents.outorgante', asc: true}]},
          {name: 'ncs_documents.soporte', criteria: [{field: 'ncs_documents.soporte', asc: true}]},
          {name: 'ncs_documents.orixe', criteria: [{field: 'ncs_documents.orixe', asc: true}]},
          {name: 'ncs_documents.identificador_edicion', criteria: [{field: 'ncs_documents.identificador_edicion', asc: true}]},
          ...Ncs.utils.defaultOrder(5),
        ],
        default: ['ncs_documents.data_orde']
      }
    },
    full_frequency: {
      groups: {
        'ncs_documents.siglos': {
          filters: ['ncs_documents.data_desde_ano', 'ncs_documents.data_ata_ano'],
          getValues: v => v.split('-'),
          // If value is null, it will be shown last, so we use MAX_VALUE
          sortBy: v => parseFloat((v || Number.MAX_VALUE.toString()).split('-', 1)[0])
        }
      }
    }
  },
  download: {
    // Allow only to download CSV to preserve previous behaviour
    kwic: [
      {name: 'download.page.csv', type: 'Page', mimeType: 'text/csv', filename: 'result.csv', pageViewName: 'download'},
    ]
  },
  pagination: {
    pageSizes: [50, 100, 500, 1000, 5000],
  },
}
